/* Theme checkout guard. Shopify checkout rules are still required for server enforcement. */
(function () {
  'use strict';
  var configNode = document.querySelector('[data-charm-cart-validation]');
  if (!configNode) return;
  var config = JSON.parse(configNode.textContent);
  var selector = '[data-checkout], [data-checkout-button], button[name="checkout"], input[name="checkout"]';
  var pending = false, replayControl = null, replayForm = null;

  function isCheckoutURL(href) {
    if (!href) return false;
    var url = new URL(href, window.location.href);
    return url.origin === window.location.origin && /\/checkout\/?$/.test(url.pathname);
  }
  function isCheckoutControl(control) {
    return control && (control.matches(selector) || isCheckoutURL(control.getAttribute('href')));
  }
  function hostFor(control) {
    return control.closest('.cart-modern, cart-drawer-modern, cart-drawer, cart-notification') || control.form || control.closest('form') || control.parentElement;
  }
  function isBlocked(control) {
    if (control.disabled || control.getAttribute('aria-disabled') === 'true') return true;
    var agreement = hostFor(control).querySelector('[data-agreement-checkbox]');
    return config.agreement_required && agreement && !agreement.checked;
  }
  function showError(control, message, builderURL) {
    var host = hostFor(control);
    var error = host.querySelector('[data-charm-cart-error]');
    if (!error) {
      error = document.createElement('div');
      error.setAttribute('data-charm-cart-error', '');
      error.setAttribute('role', 'alert');
      error.setAttribute('tabindex', '-1');
      error.style.cssText = 'padding:12px;margin:12px 0;border:1px solid currentColor;font-size:14px;line-height:1.5;';
      control.parentElement.insertBefore(error, control);
    }
    error.textContent = message;
    if (builderURL) {
      var link = document.createElement('a');
      link.href = builderURL;
      link.textContent = ' Kolye tasarımına git';
      link.style.textDecoration = 'underline';
      error.appendChild(link);
    }
    error.focus();
  }
  async function check(event, control, form) {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (pending) return;
    pending = true;
    control.setAttribute('aria-busy', 'true');
    try {
      var url = new URL(config.cart_url, window.location.origin);
      url.searchParams.set('section_id', 'charm-cart-validation');
      url.searchParams.set('_', String(Date.now()));
      var response = await fetch(url.href, { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) throw new Error('Cart validation failed');
      var doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      var node = doc.querySelector('[data-charm-cart-validation]');
      if (!node) throw new Error('Cart validation missing');
      var result = JSON.parse(node.textContent);
      if (typeof result.valid !== 'boolean') throw new Error('Invalid cart validation');
      if (!result.valid) {
        showError(control, result.message, result.builder_url);
        return;
      }
      var previousError = hostFor(control).querySelector('[data-charm-cart-error]');
      if (previousError) previousError.remove();
      if (!control.isConnected || isBlocked(control)) return;
      replayControl = control;
      replayForm = form || control.form;
      // Replay through theme handlers so agreement checks and native form behavior remain intact.
      if (form) form.requestSubmit(control === form ? undefined : control);
      else control.click();
    } catch (error) {
      showError(control, 'Sepet kontrol edilemedi. Lütfen yeniden deneyin.');
    } finally {
      replayControl = null;
      replayForm = null;
      pending = false;
      control.removeAttribute('aria-busy');
    }
  }
  document.addEventListener('click', function (event) {
    var control = event.target.closest(selector + ', a[href]');
    if (!isCheckoutControl(control) || control === replayControl || event.defaultPrevented || isBlocked(control)) return;
    check(event, control, null);
  }, true);
  document.addEventListener('submit', function (event) {
    var form = event.target;
    var control = event.submitter || form;
    if (form === replayForm || event.defaultPrevented) return;
    if (!isCheckoutControl(control) && !isCheckoutURL(form.getAttribute('action'))) return;
    if (isBlocked(control)) return;
    check(event, control, form);
  }, true);
})();
